// テーマ外のカスタマイズ用

// タブ切り替え関数
export function initializeTabs(sectionId) {
  const selector = sectionId ? `#${sectionId}` : '';
  
  // 初期化処理 - 最初のタブにactiveクラスを付与
  function setupInitialState() {
    // 最初のメインタブにactiveクラスを付与
    const firstMainTab = document.querySelector(`${selector} .main-tab-nav span`);
    if (firstMainTab) {
      firstMainTab.classList.add('active');
    }
    
    // 最初のコンテンツエリアにactiveクラスを付与
    const firstContentArea = document.querySelector(`${selector} .tab-content-area`);
    if (firstContentArea) {
      firstContentArea.classList.add('active');
    }
    
    // 各コンテンツエリアの最初のサブタブと最初のサブコンテンツにactiveクラスを付与
    document.querySelectorAll(`${selector} .tab-content-area`).forEach(area => {
      const firstSubTab = area.querySelector('.sub-tab-nav span');
      const firstSubContent = area.querySelector('.sub-content');
      
      if (firstSubTab) {
        firstSubTab.classList.add('active');
      }
      if (firstSubContent) {
        firstSubContent.classList.add('active');
      }
    });
  }
  
  // メインタブの制御
  function setupMainTabs() {
    document.querySelectorAll(`${selector} .main-tab-nav span`).forEach((tab, mainIndex) => {
      tab.addEventListener('click', function() {
        // すべてのメインタブを非アクティブにする
        document.querySelectorAll(`${selector} .main-tab-nav span`).forEach(t => {
          t.classList.remove('active');
        });
        
        // すべてのコンテンツエリアを非表示にする
        document.querySelectorAll(`${selector} .tab-content-area`).forEach(area => {
          area.classList.remove('active');
        });
        
        // 選択されたタブとコンテンツをアクティブにする
        this.classList.add('active');
        const targetArea = document.querySelectorAll(`${selector} .tab-content-area`)[mainIndex];
        if (targetArea) {
          targetArea.classList.add('active');
        }
      });
    });
  }
  
  // 初期化実行
  setupInitialState();
  setupMainTabs();
}


// Splideスクロールバー関数
export function createSplideScrollbar(splideElement, scrollbarElement, options = {}) {
  const scrollbar = typeof scrollbarElement === 'string' ?
    document.querySelector(scrollbarElement) :
    scrollbarElement;
  const thumb = scrollbar.querySelector('.splide-scrollbar-thumb');

  if (!scrollbar || !thumb) {
    console.error('Scrollbar or thumb element not found');
    return null;
  }

  let isDragging = false;
  let animationFrame = null;
  let dragAnimationFrame = null;

  // デフォルト設定
  const config = {
    updateTransition: 'all 0.6s cubic-bezier(0.25, 1, 0.5, 1)',
    dragEndTransition: 'all 0.3s ease',
    ...options
  };

  // スクロールバーの位置を更新
  function updateScrollbar() {
    if (isDragging) return;

    if (animationFrame) {
      cancelAnimationFrame(animationFrame);
    }

    animationFrame = requestAnimationFrame(() => {
      const totalSlides = splideElement.length;
      const currentIndex = splideElement.index;
      const maxIndex = splideElement.Components.Controller.getEnd();

      if (maxIndex === 0) return;

      const progress = currentIndex / maxIndex;
      const thumbWidth = (splideElement.options.perPage / totalSlides) * 100;

      thumb.style.transition = config.updateTransition;
      thumb.style.width = thumbWidth + '%';
      thumb.style.left = (progress * (100 - thumbWidth)) + '%';
    });
  }

  // ドラッグ処理
  function handleDrag(clientX) {
    if (!isDragging) return;

    if (dragAnimationFrame) {
      cancelAnimationFrame(dragAnimationFrame);
    }

    dragAnimationFrame = requestAnimationFrame(() => {
      const rect = scrollbar.getBoundingClientRect();
      const clickPosition = clientX - rect.left;
      const scrollbarWidth = rect.width;
      const totalSlides = splideElement.length;
      const thumbWidth = (splideElement.options.perPage / totalSlides) * 100;
      const thumbWidthPx = (thumbWidth / 100) * scrollbarWidth;

      // サムの中心位置を基準に計算
      let newThumbLeft = clickPosition - (thumbWidthPx / 2);
      const maxThumbLeft = scrollbarWidth - thumbWidthPx;
      newThumbLeft = Math.max(0, Math.min(newThumbLeft, maxThumbLeft));

      // パーセンテージに変換
      const newThumbLeftPercent = (newThumbLeft / scrollbarWidth) * 100;
      const maxLeftPercent = 100 - thumbWidth;

      // スクロールバーの位置を直接更新
      thumb.style.transition = 'none';
      thumb.style.left = Math.min(newThumbLeftPercent, maxLeftPercent) + '%';

      // スライダーの位置を計算
      const progress = Math.max(0, Math.min(1, newThumbLeftPercent / maxLeftPercent));
      const targetIndex = Math.round(progress * splideElement.Components.Controller.getEnd());

      splideElement.go(targetIndex, false);
    });
  }

  // イベントリスナーの登録
  function bindEvents() {
    // Splideイベント
    splideElement.on('move', updateScrollbar);
    splideElement.on('moved', updateScrollbar);
    splideElement.on('mounted', updateScrollbar);
    splideElement.on('resize', updateScrollbar);

    // スクロールバーのクリックイベント
    scrollbar.addEventListener('click', function (e) {
      if (e.target === thumb) return;

      const rect = scrollbar.getBoundingClientRect();
      const progress = (e.clientX - rect.left) / rect.width;
      const targetIndex = Math.round(progress * splideElement.Components.Controller.getEnd());

      splideElement.go(targetIndex);
    });

    // マウスドラッグ
    thumb.addEventListener('mousedown', function (e) {
      isDragging = true;
      e.preventDefault();

      function onMouseMove(e) {
        handleDrag(e.clientX);
      }

      function onMouseUp() {
        isDragging = false;
        thumb.style.transition = config.dragEndTransition;
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
      }

      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
    });

    // タッチドラッグ
    thumb.addEventListener('touchstart', function (e) {
      isDragging = true;
      e.preventDefault();

      function onTouchMove(e) {
        handleDrag(e.touches[0].clientX);
      }

      function onTouchEnd() {
        isDragging = false;
        thumb.style.transition = config.dragEndTransition;
        document.removeEventListener('touchmove', onTouchMove);
        document.removeEventListener('touchend', onTouchEnd);
      }

      document.addEventListener('touchmove', onTouchMove);
      document.addEventListener('touchend', onTouchEnd);
    });
  }

  // 破棄処理
  function destroy() {
    if (animationFrame) cancelAnimationFrame(animationFrame);
    if (dragAnimationFrame) cancelAnimationFrame(dragAnimationFrame);

    splideElement.off('move', updateScrollbar);
    splideElement.off('moved', updateScrollbar);
    splideElement.off('mounted', updateScrollbar);
    splideElement.off('resize', updateScrollbar);
  }

  // 初期化
  bindEvents();

  // パブリックAPI
  return {
    update: updateScrollbar,
    destroy: destroy,
    setConfig: (newConfig) => Object.assign(config, newConfig)
  };
}

// ------------------ Splideスクロールバー関数ここまで


// レビューアプリ
function initReviewApp() {
  let product_review_handler = '[id^="shopify-section-template"][id$="mxpr-product-reviews"]';
  let targetSection = document.querySelector(product_review_handler);

  // セクションが存在しない場合は処理を中断
  if (!targetSection) return;

// 閉じるボタンの注入（まだ追加されていない場合のみ）
  if (!targetSection.querySelector('.product-review__close')) {

    const iconUrl = window.themeAssets?.arrow_down_03;

    targetSection.insertAdjacentHTML(
      "afterbegin",
      `<span class="product-review__close">
       <img src="${iconUrl}" alt="CLOSE">
     </span>`
    );
  }

  // 背景要素の注入（まだ追加されていない場合のみ）
  if (!document.querySelector('.product-review___back')) {
    targetSection.insertAdjacentHTML(
      "afterend",
      '<div class="product-review___back"></div>'
    );
  }

  // イベントリスナーの重複登録を防ぐために .off("click") を挟んで登録
  $(".custom-product-review-wrapper .button-secondary").off("click").on("click", function (e) {
    e.preventDefault();
    $("body").toggleClass("product-review--open overflow-hidden");
    $(product_review_handler).toggleClass("is-open");
    $(".product-review___back").toggleClass("is-open");
  });

  $(document).off("click", ".product-review__close").on("click", ".product-review__close", function () {
    $("body").removeClass("product-review--open overflow-hidden");
    $(product_review_handler).removeClass("is-open");
    $(".product-review___back").removeClass("is-open");
  });

  $(document).off("click", ".product-review___back").on("click", ".product-review___back", function () {
    $("body").removeClass("product-review--open overflow-hidden");
    $(product_review_handler).removeClass("is-open");
    $(".product-review___back").removeClass("is-open");
  });
}

// ① 初回読み込み時の実行
document.addEventListener('DOMContentLoaded', initReviewApp);

// ② バリエーション変更時の再実行
// 通信完了（DOMの書き換え完了）のタイミングが予測できないため、
// setIntervalを使用して約1.5秒間の間に複数回チェックして注入を試みる設計に変更
function onVariantChange() {
  let checkCount = 0;
  const intervalId = setInterval(() => {
    initReviewApp();
    checkCount++;
    // 300ms × 6回 = 約1.8秒間チェックしたら監視を終了する
    if (checkCount >= 6) {
      clearInterval(intervalId);
    }
  }, 300);
}

if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
} else {
  // 万が一PubSubが使えない場合のフォールバック
  document.addEventListener('change', (e) => {
    if (e.target.closest('variant-radios, variant-selects, .variant-picker')) {
      onVariantChange();
    }
  });
}

// LP用ブロックのポップアップ処理
document.addEventListener('DOMContentLoaded', () => {

  ['01', '02', '03'].forEach(num => {
    const block = document.querySelector(`.lp-block${num}`);
    if (!block) return;
    const cntWrap = block.querySelector(
      `.lp-block${num}-cnt > .group-block-content`
    );
    const puWrap = block.querySelector(
      `.lp-block${num}-pu > .group-block-content`
    );
    const modalWrap = block.querySelector(`.lp-block${num}-pu`);
    if (!cntWrap || !puWrap || !modalWrap) return;
    const cntItems = cntWrap.querySelectorAll(
      `:scope > .lp-block${num}-cnt-item`
    );
    const puItems = puWrap.querySelectorAll(
      `:scope > .lp-block${num}-pu-item`
    );

    cntItems.forEach((item, index) => {
      item.addEventListener('click', () => {
        puItems.forEach(pu => {
          pu.classList.remove('active');
        });
        if (puItems[index]) {
          puItems[index].classList.add('active');
        }
        modalWrap.classList.add('active');
        document.body.classList.add('modal-open');
      });
    });

    modalWrap.addEventListener('click', (e) => {
      const popupItem = e.target.closest(`.lp-block${num}-pu-item`);
      if (!popupItem) {
        modalWrap.classList.remove('active');
        puItems.forEach(pu => {
          pu.classList.remove('active');
        });
        document.body.classList.remove('modal-open');
      }

      if (e.target.closest('.modal-close')) {
        modalWrap.classList.remove('active');
        puItems.forEach(pu => {
          pu.classList.remove('active');
        });
        document.body.classList.remove('modal-open');
      }
    });
  });
});

// フェードイン
const targets = document.querySelectorAll('.wp');
const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-show');
    }
  });
}, {
  threshold: 0.2
});
targets.forEach((target) => {
  observer.observe(target);
});

// サスティナブルアクションのポップアップ
document.addEventListener('DOMContentLoaded', () => {
  
  const modal = document.querySelector('.seasonal-flower-concept-pu');
  if (!modal) return;
  const openButtons = document.querySelectorAll(
    '.seasonal-flower-concept-block .button, .seasonal-flower-concept-block .button-secondary'
  );
  const modalWrap = document.querySelector(
    '.shopify-section:has(> .seasonal-flower-concept-pu-wrap)'
  );
  const closeButton = modal.querySelector('.modal-close');

  openButtons.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      if (modalWrap) {
        modalWrap.classList.add('is-active');
        document.body.classList.add('is-fixed');
      }
    });
  });

  if (closeButton) {
    closeButton.addEventListener('click', () => {
      if (modalWrap) {
        modalWrap.classList.remove('is-active');
        document.body.classList.remove('is-fixed');
      }
    });
  }

});